import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-670c83d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "file-item-author"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-file-item-wrapper", { 'file-item-wrapper--column': _ctx.columnView }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["file-item", _ctx.hideText])
      }, [
        _createVNode(_component_el_skeleton, {
          class: "file-item-skeleton",
          animated: "",
          style: {"--el-skeleton-color":"#AFBEC7"}
        }, {
          template: _withCtx(() => [
            _createVNode(_component_el_skeleton_item, {
              variant: "rect",
              class: "fullsize"
            })
          ]),
          _: 1
        })
      ], 2),
      (!_ctx.hideText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_skeleton, {
              animated: "",
              style: {"--el-skeleton-color":"#AFBEC7"}
            }, {
              template: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, { variant: "text" })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}